import React, { Component } from 'react';
import { connect } from 'react-redux';
import {clearError} from '../reducers/page'

class Loading extends Component {
	componentWillReceiveProps(nextProps) {
		const {error} = nextProps
		
		if(error!==null && this.props.error===null) {
			setTimeout(() => {
				this.props.clearError()
			}, 5000)
		}
    }
	render() {
		const { error } = this.props
		return (
			<div className={'snackbar' + (error!==null?' visible':'')}>
				{error && <span>Eroare: {error.message}</span>}
			</div>
		)
  	}
}

function mapStateToProps(state) {
	return {
		error: state.page.error
	}
}

export default connect(mapStateToProps, {clearError})(Loading);



// WEBPACK FOOTER //
// ./src/fm/lib/Loading.js